import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const udpReadUiNodeSpec: UiNodeSpec<'udpRead'> = {
    requiredSockets: (node, _, availableOutputSockets) => ({ required: [], conditionallyRequired: [ { kind: 'or', availableOptions: availableOutputSockets } ] }),
    cfg: () => ({ controlValues: { encoding: 'utf8', hostInterface: '', port: 1024 }, id: getUID(), kind: 'udpRead', disabled: false }),
    controls: getNodeCfg => ({
        encoding: { cfg: { kind: 'text', label: 'Encoding', optional: true }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.encoding },
        hostInterface: { cfg: { kind: 'text', label: 'IP' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.hostInterface },
        port: { cfg: { kind: 'number', label: 'Port', min: 1024 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.port },
    }),
    inputs: () => ({}),
    kindLabel: 'UDP Read',
    nodeCategory: 'external',
    outputs: () => ({
        event: { socket: 'event', label: 'On Received' },
        payload: { socket: 'string', label: 'Payload' },
    }),
    validator: node => {

        const errors: Record<string, string> = {};
        if (!node.controlValues.port) {
            errors.port = 'Port is required';
        }
        if (!node.controlValues.hostInterface) {
            errors.hostInterface = 'IP is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
